const TrajectorySection = () => {
  return (
    <section className="trajectory-section">
      <div className="trajectory-container">

        <div className="text-center mx-auto trajectory-content">

          <h2 className="trajectory-label">
            NUESTRA TRAYECTORIA
          </h2>

          <p className="trajectory-text mt-4">
            Con años de experiencia en el sector de alquiler de vehículos en Talara, <strong>Talara Rent a Car</strong> nació con el 
            objetivo de brindar soluciones de movilidad confiables para quienes visitan o trabajan en el norte del Perú. 
            Desde nuestros inicios, nos hemos enfocado en ofrecer un servicio eficiente, vehículos en óptimas condiciones 
            y una atención cercana que garantice una experiencia segura y cómoda en cada viaje.
          </p>

          <p className="trajectory-text mt-3">
            A lo largo del tiempo hemos consolidado una flota moderna de autos, camionetas, SUVs y más vehículos, adaptada tanto a las necesidades 
            de turistas como de empresas que operan en la región. Nuestro compromiso con la puntualidad, la seguridad y el servicio 
            personalizado nos ha permitido convertirnos en una opción confiable para quienes buscan alquilar un vehículo en Talara.
          </p>

          <p className="trajectory-text mt-3">
            Hoy continuamos creciendo con la misma filosofía que nos impulsó desde el inicio: ofrecer movilidad con confianza, 
            calidad y atención profesional en cada kilómetro recorrido.
          </p>

        </div>

      </div>

      <style>
        {`
        .trajectory-section{
          display: flex;
    justify-content: center;
    align-items: center;
    padding: 8rem 0; /* py-14 */
    width: 100%; /* w-full */
        }

        .trajectory-container{
         display: flex;
    flex-direction: column; /* flex-col */
    justify-content: center;
    align-items: center;
    gap: 1.25rem; /* gap-5 */
    width: 90vw; /* w-[90vw] */
        }

        @media (min-width: 768px) {
    .trajectory-container {
      width: 75vw; /* md:w-[75vw] */
    }
  }

  @media (min-width: 1024px) {
    .trajectory-container {
      flex-direction: row; /* lg:flex-row */
    }
  }

        .trajectory-content{
          max-width:800px;
        }

        .trajectory-label{
          font-weight: bold;
            color: #d22222;
            font-size: 2.5rem;
            text-align: center;
        }

        .trajectory-title{
          font-size:1.8rem;
          font-weight:700;
          color:#222;
        }

        .trajectory-text{
          color: #4a4a4a;
            font-size: 1.25rem;
            text-align: justify;
        }

        @media (min-width:768px){
          .trajectory-title{
            font-size:2.3rem;
          }

          .trajectory-text{
            font-size:1.25rem;
          }
        }

        @media (min-width:1200px){
          .trajectory-title{
            font-size:2.6rem;
          }
        }
        `}
      </style>

    </section>
  )
}

export default TrajectorySection